import Vue from "vue";
import functions from "./utils/functions"; // 全局方法
import inputDirective from "./utils/inputDirective"; // 全局方法
import directives from "./config/directives"; // 全局指令
// 引入交建组件库
import {
  InfiniteScroll,
  Table,
  CascaderPanel,
  // Aside,
  TableColumn,
  Dialog,
  Menu,
  MenuItem,
  TopNavMenu,
  Scrollbar,
  TimelineApproval,
  Loading,
  Submenu,
  Col,
  CardTitle,
  Row,
  Progress,
  Card,
  Tag,
  Tabs, // tabs页签
  TabPane, // tab页签选项
  DataCard,
  Timeline,
  TimelineItem,
  Button,
  Alert,
  Popover,
  CheckboxGroup,
  Checkbox,
  Pagination,
  Input,
  Label,
  Breadcrumb,
  BreadcrumbItem,
  HistoryList,
  Form,
  FormItem,
  BottomPrintExport,
  TagSelector,
  Select,
  Option,
  Message,
  Search,
  TopNavMenu2,
  DatePicker,
  InputTagDatePicker,
  DetailInfo,
  Radio,
  RadioButton,
  RadioGroup,
  SimpleFooter,
  Upload,
  FileUpload,
  MultiLevelSelector,
  ServiceSelector,
  Tree,
  TopNavMenu4,
  TopNavMenu3,
  Cascader,
  EmpFooter,
  Autocomplete,
  Image,
  CheckboxTable,
  Main,
  Aside,
  Steps,
  Step,
  DialogMultiCheckboxGroup,
  Slider,
  Tooltip,
  MessageBox,
  InputNumber,
  BottomGuide,
  GroupTitle,
  RegionSelector,
} from "ccui";

import tableList from "./common/table-list";

import "ccui/lib/theme-chalk/index.css"; // CCUI样式

import App from "./App.vue";
import router from "./router";
import store from "./store";
import eventBus from "@/utils/msgBus.js";
// import './mock' // mock数据
import "./permission"; // permission control
import "./icons"; // SVG
import crypto from "./utils/crypto";
import "@/styles/index.scss"; // global css
import Cookies from "js-cookie";
Vue.prototype.msgCenter = new Vue()
// 多语言
import i18n from '@/i18n';
import locale from "ccui/lib/locale";

import * as filters from "./filters"; // global filters
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.directive('input',inputDirective)

// 注册全局组件
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox;
window.$message = Message;
Vue.prototype.tableList = tableList;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$crypto = crypto;
Vue.prototype.languagezh_cn = (Cookies.get("language") || "zh-cn") === "zh-cn";
if (window)
  window.languagezh_cn = (Cookies.get("language") || "zh-cn") === "zh-cn";
if (window) window.$t = (key, value) => i18n.t(key, value);
locale.i18n((key, value) => i18n.t(key, value));
//
Vue.use(functions);
Vue.use(Table);
Vue.use(TableColumn);
// Vue.use(ElementUI);
Vue.use(EmpFooter);
Vue.use(CascaderPanel);
Vue.use(Tree);
Vue.use(Aside);
Vue.use(Loading);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(CardTitle);
Vue.use(TimelineApproval);
Vue.use(TopNavMenu);
Vue.use(directives);
Vue.use(MenuItem);
Vue.use(InfiniteScroll);
Vue.use(HistoryList);
Vue.use(Menu);
Vue.use(Scrollbar);
Vue.use(Submenu);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Label);
Vue.use(Progress);
Vue.use(Card);
Vue.use(Tag);
Vue.use(BottomPrintExport);
Vue.use(DataCard);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Alert);
Vue.use(Button);
Vue.use(Popover);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Input);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(BottomPrintExport);
Vue.use(TagSelector);
Vue.use(Select);
Vue.use(Option);
Vue.use(Search);
Vue.use(TopNavMenu2);
Vue.use(DatePicker);
Vue.use(InputTagDatePicker);
Vue.use(DetailInfo);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(SimpleFooter);
Vue.use(FileUpload);
Vue.use(Cascader);
Vue.use(Upload);
Vue.use(MultiLevelSelector);
Vue.use(ServiceSelector);
Vue.use(TopNavMenu4);
Vue.use(TopNavMenu3);
Vue.use(Autocomplete);
Vue.use(Image);
Vue.use(CheckboxTable);
Vue.use(Main);
Vue.use(Aside);
Vue.use(DialogMultiCheckboxGroup);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Slider);
Vue.use(Tooltip);
Vue.use(Pagination);
Vue.use(InputNumber);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(BottomGuide);
Vue.use(GroupTitle);
Vue.use(RegionSelector);
console.log(i18n)
new Vue({
  router,
  store,
  i18n,
  el: "#app",
  render: h => h(App)
}).$mount("#app");
